import { useContext, useState } from "react";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { PortalContext } from "_+_Portal/context/Provider";
import MercadoPagoLogo from "_+_Portal/assets/images/generico/MercadoPagoLogo";
import {
  wsGetMercadoPagoLaboratorioQr,
  wsGetMercadoPagoTurnosQr,
} from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { GlobalContext } from "global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { useHistory } from "react-router";
import { Container, Btns, Header, Price } from "./localStyle";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { mercadoPagoReset } from "_+_Portal/context/Actions/mercadoPago/mercadoPago";

// Pantalla de selección de pago MP para desktop/tablet (genera referencia y redirige a QR)
const MercadoPagoDesktop = () => {
  const history = useHistory();
  const { turnosSeleccionadosState, pasoDispatch, rutaState, pasoState } =
    useContext(AutocheckContext);
  const { mercadoPagoDispatch } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  const actual = rutaState?.ruta?.data?.actual ?? 0;
  const turnosSel = turnosSeleccionadosState?.turnosSeleccionados?.data || [];
  const turno = turnosSel[actual] || {};
  const [loading, setLoading] = useState(false);

  const nextStep = (isCorrect) => {
    if (isCorrect) {
      setLoading(false);
      history.push("/autocheckinDesktop/MercadoPagoQR");
    } else {
      setLoading(false);
      history.push("/autocheckinDesktop/puntoControl?idtipo=8");
    }
  };

  const handleClickMP = () => {
    setLoading(true);
    if (turno?.idProtocolo > 0) {
      wsGetMercadoPagoLaboratorioQr(
        turno.idProtocolo,
        nextStep
      )(mercadoPagoDispatch);
    } else {
      wsGetMercadoPagoTurnosQr(turno.idturno, nextStep)(mercadoPagoDispatch);
    }
  };

  const handleClickEfectivo = () => {
    history.push("/autocheckinDesktop/puntoControl?idtipo=8");
  };

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion="Generando código QR..."
      />
      <LayoutPasos
        handleClick={() => {
          mercadoPagoReset()(mercadoPagoDispatch);
          history.push("/autocheckin");
          if (pasoState.circuito === "labo") {
            setPaso("TurnosDelDiaLabo")(pasoDispatch);
          } else {
            setPaso("TurnosDelDia")(pasoDispatch);
          }
        }}
        type={"no-circle"}
        title={"Abonar MP"}
      >
        <Container>
          <Header>
            <CardBlueHeart
              medico={turno?.medico ? turno?.medico : turno?.especialidad}
              turnoTitle={turno?.especialidad}
              pasoActual={actual + 1}
              pasoTotal={
                turnosSeleccionadosState.turnosSeleccionados?.data?.length ?? 0
              }
            />
            <PasoBar paso={"AbonarMP"} />
          </Header>
          <Price>
            <span className="rb18m">
              Te falta un paso para finalizar la recepción.
            </span>
            <span className="rb18m">El valor del turno es</span>
            <span className="rb48m">
              ${turno?.resumen?.monto ?? turno?.monto ?? 0}
            </span>
          </Price>
          <Btns>
            <button
              className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30"
              onClick={handleClickMP}
            >
              <MercadoPagoLogo width={100} />
            </button>
            <button
              className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
              onClick={handleClickEfectivo}
            >
              Efectivo
            </button>
          </Btns>
        </Container>
      </LayoutPasos>
    </>
  );
};

export default MercadoPagoDesktop;
